import { apiRequest } from '@common/api/utils';
import cogoToast from 'cogo-toast';


async function chatbotAccess(chatbotSlug) {
  try {
    await apiRequest(
      'POST',
      `/api/v3/assisted_requests/chatbots/${chatbotSlug}/init`,
    );
    return true;
  } catch (error) {
    return false;
  }
}

async function sendQuestion(chatbotSlug, prompt) {
  try {
    const response = await apiRequest(
      'POST',
      `/api/v3/assisted_requests/chatbots/${chatbotSlug}/stream`, {
        query: prompt,
        use_conversation_history: false,
      },
    );

    return response;
  } catch (error) {
    cogoToast.error('Please retry again');
    return error;
  }
}

async function getChats(chatbotSlug, page, messages) {
  try {
    const response = await apiRequest(
      'GET',
      `/api/v3/assisted_requests/chatbots/${chatbotSlug}/history`, {
        page,
        limit: messages,
      },
    );

    return response;
  } catch (error) {
    cogoToast.error('Please retry again');
    return error;
  }
}

export default {
  chatbotAccess,
  sendQuestion,
  getChats,
};
